//import OktaUserDetails from './OktaUserDetails'
export function authHeader()
{
   // const oktaUserDetails = new OktaUserDetails();
    //return 'Bearer ' + oktaUserDetails.getAccessToken();
    return 'X-API-KEY ' + `${process.env.VUE_APP_ROOT_API_KEY}`
}